module.exports = __webpack_public_path__ + "static/media/survive-r.3a292a55.png";